import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const badgeCss = ":host([label]){-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;align-items:center;background-color:var(--jw-theme-info-muted-message-inverted-bg-color);border-radius:624.9375rem;box-sizing:border-box;color:var(--jw-theme-info-muted-message-inverted-color);display:inline-flex;flex:none;font-family:Open Sans;font-size:.875rem;font-size:.75rem;font-weight:400;height:1rem;justify-content:center;letter-spacing:-.0004em;letter-spacing:0;line-height:1.25rem;line-height:normal;line-height:1rem;line-height:0;min-width:1rem;padding:0 .25rem;width:-webkit-fit-content;width:fit-content}:host([label]) *,:host([label]) :after,:host([label]) :before{box-sizing:inherit}:host([label]) img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host([label=\"0\"]){display:none}";
const WuiBadgeStyle0 = badgeCss;

const WuiBadge = /*@__PURE__*/ proxyCustomElement(class WuiBadge extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.label = undefined;
    }
    render() {
        return h(Host, { key: 'f0d2139957c00ea9c2224f55494e89a265c81b18' }, this.label);
    }
    static get style() { return WuiBadgeStyle0; }
}, [1, "wui-badge", {
        "label": [514]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-badge"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-badge":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiBadge);
            }
            break;
    } });
}
defineCustomElement();

export { WuiBadge as W, defineCustomElement as d };

//# sourceMappingURL=badge.js.map